import { Box, Typography, Button } from "@mui/material";
import { WindowActionsBar } from "@progress/kendo-react-dialogs";
import i18_en from '../../../jsonStore/i18_en.json';

export const MessageComponent = () => {
  return (
    <Box sx={{ width: 350, bgcolor: "background.paper", p: 3 }}>
      {i18_en.resourceDeallocateMessage}
    </Box>
  )
}

export const RenderActionButtons = (props) => {
  const { onClose, onConfirm } = { ...props };
  return (
    <>
      <Button variant='contained' onClick={onConfirm} size='small'>
        Yes
      </Button>
      <Button variant='outlined' onClick={onClose} size='small'>
        No
      </Button>
    </>
  )
}

const DeleteConfirmationComponent = (props) => {
    const { value, onClose, onConfirm } = { ...props };

    return (
      <>
        <Box sx={{ width: 350, bgcolor: "background.paper", p: 3 }}>
          <Typography variant="h6" sx={{ pr: .5, justifyContent: 'center', fontSize: '15px' }}>{i18_en.deleteConfirmationMessage}{" "}<span style={{ fontWeight: "bold" }}>{value}</span> item?</Typography>
        </Box>
        <WindowActionsBar>
          <Button
            variant="outlined"
            size="small"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant="outlined"
            size="small"
            onClick={onConfirm}
          >
            Confirm
          </Button>
        </WindowActionsBar>
      </>
    )
}

export default DeleteConfirmationComponent;